import { Schedule } from '../schedule-models/schedule.model';
import { Desk } from './desk.model';

export class FormBasic {

    private accessListEnable: boolean;
    private active: boolean;
    private addDni: boolean;
    private addMail: boolean;
    private addName: boolean;
    private addSurname: boolean;
    private addTelephone: boolean;
    private addDocument: boolean;
    private addLicensePlate: boolean;
    private addCard: boolean;
    private addPassport: boolean;
    private allowBefore: number;
    private allowAfter: number;
    private appointmentTokenLength: number;
    private calendarsBound: Schedule[];
    private availabilityCalendarsBound: Schedule[];
    private centerInternalId: string;
    private centerName: string;
    private checkListUserAccount: boolean;
    private daysToShow: number;
    private daysToShowPrivate: number;
    private desksBound: Desk[];
    private internalId: string;
    private intervalCapacity: number;
    private intervalDuration: number;
    private intervalOccupacityAlert: number;
    private maxReservation: number;
    private maxTurnsPerDayByService: number;
    private msessionInternalId: string;
    private msessionName: string;
    private online: boolean;
    private reservationForDay: number;
    private latitude: number;
    private longitude: number;
    private distanceInMeters: number;
    private showEstimatedTime: boolean;
    private turnFormName: string;
    private urlTurnForm: string;
    private urlAppointmentForm: string;
    private showEndTime: boolean;

    constructor(accessListEnable?: boolean, active?: boolean, allowBefore?: number, allowAfter?: number, addDni?: boolean, addMail?: boolean, addName?: boolean, addSurname?: boolean, addTelephone?: boolean, addDocument?: boolean, addLicensePlate?: boolean, addPassport?: boolean, addCard?: boolean, appointmentTokenLength?: number, calendarsBound?: Schedule[], centerInternalId?: string, centerName?: string, checkListUserAccount?: boolean, daysToShow?: number, daysToShowPrivate?: number, desksBound?: Desk[], internalId?: string, intervalCapacity?: number, intervalDuration?: number, intervalOccupacityAlert?: number, maxReservation?: number, msessionInternalId?: string, msessionName?: string, online?: boolean, reservationForDay?: number, turnFormName?: string, urlTurnForm?: string,  urlAppointmentForm?: string, showEndTime?: boolean, maxTurnsPerDayByService?: number, latitude?: number, longitude?: number, distanceInMeters?: number, showEstimatedTime?: boolean, availabilityCalendarsBound?: Schedule[]) {
        this.accessListEnable = accessListEnable;
        this.active = active;
        this.allowBefore = allowBefore;
        this.allowAfter = allowAfter;
        this.addDni = addDni;
        this.addMail = addMail;
        this.addName = addName;
        this.addSurname = addSurname;
        this.addTelephone = addTelephone;
        this.addDocument = addDocument;
        this.addLicensePlate = addLicensePlate;
        this.addPassport = addPassport;
        this.addCard = addCard;
        this.calendarsBound = calendarsBound;
        this.availabilityCalendarsBound = availabilityCalendarsBound;
        this.centerInternalId = centerInternalId;
        this.centerName = centerName;
        this.checkListUserAccount = checkListUserAccount;
        this.daysToShow = daysToShow;
        this.daysToShowPrivate = daysToShowPrivate;
        this.desksBound = desksBound;
        this.internalId = internalId;
        this.intervalCapacity = intervalCapacity;
        this.intervalDuration = intervalDuration;
        this.intervalOccupacityAlert = intervalOccupacityAlert;
        this.maxReservation = maxReservation;
        this.msessionInternalId = msessionInternalId;
        this.msessionName = msessionName;
        this.online = online;
        this.reservationForDay = reservationForDay;
        this.turnFormName = turnFormName;
        this.urlTurnForm = urlTurnForm;
        this.urlAppointmentForm = urlAppointmentForm;
        this.showEndTime = showEndTime;
        this.maxTurnsPerDayByService = maxTurnsPerDayByService;
        this.latitude = latitude;
        this.longitude = longitude;
        this.distanceInMeters = distanceInMeters;
        this.showEstimatedTime = showEstimatedTime;
    }

    public get AccessListEnable() {
        return this.accessListEnable;
    }
    public set AccessListEnable(accessListEnable) {
        this.accessListEnable = accessListEnable;
    }
    public get Active() {
        return this.active;
    }
    public set Active(active) {
        this.active = active;
    }
    public get AllowAfter() {
        return this.allowAfter;
    }
    public set AllowAfter(allowAfter) {
        this.allowAfter = allowAfter;
    }
    public get AllowBefore() {
        return this.allowBefore;
    }
    public set AllowBefore(allowBefore) {
        this.allowBefore = allowBefore;
    }
    public get AddDni() {
        return this.addDni;
    }
    public set AddDni(addDni) {
        this.addDni = addDni;
    }
    public get AddMail() {
        return this.addMail;
    }
    public set AddMail(addMail) {
        this.addMail = addMail;
    }
    public get AddName() {
        return this.addName;
    }
    public set AddName(addName) {
        this.addName = addName;
    }
    public get AddSurname() {
        return this.addSurname;
    }
    public set AddSurname(addSurname) {
        this.addSurname = addSurname;
    }
    public get AddTelephone() {
        return this.addTelephone;
    }
    public set AddTelephone(addTelephone) {
        this.addTelephone = addTelephone;
    }
    public get AddDocument() {
        return this.addDocument;
    }
    public set AddDocument(addDocument) {
        this.addDocument = addDocument;
    }
    public get AddCard() {
        return this.addCard;
    }
    public set AddCard(addCard) {
        this.addCard = addCard;
    }
    public get AddPassport() {
        return this.addPassport;
    }
    public set AddPassport(addPassport) {
        this.addPassport = addPassport;
    }
    public get AddLicensePlate() {
        return this.addLicensePlate;
    }
    public set AddLicensePlate(addLicensePlate) {
        this.addLicensePlate = addLicensePlate;
    }
    public get AppointmentTokenLength() {
        return this.appointmentTokenLength;
    }
    public set AppointmentTokenLength(appointmentTokenLength) {
        this.appointmentTokenLength = appointmentTokenLength;
    }
    public get CalendarsBound() {
        return this.calendarsBound;
    }
    public set CalendarsBound(calendarsBound) {
        this.calendarsBound = calendarsBound;
    }
    public get AvailabilityCalendarsBound() {
        return this.availabilityCalendarsBound;
    }
    public set AvailabilityCalendarsBound(availabilityCalendarsBound) {
        this.availabilityCalendarsBound = availabilityCalendarsBound;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public get CheckListUserAccount() {
        return this.checkListUserAccount;
    }
    public set CheckListUserAccount(checkListUserAccount) {
        this.checkListUserAccount = checkListUserAccount;
    }
    public get DaysToShow() {
        return this.daysToShow;
    }
    public set DaysToShow(daysToShow) {
        this.daysToShow = daysToShow;
    }
    public get DaysToShowPrivate() {
        return this.daysToShowPrivate;
    }
    public set DaysToShowPrivate(daysToShowPrivate) {
        this.daysToShowPrivate = daysToShowPrivate;
    }
    public get DesksBound() {
        return this.desksBound;
    }
    public set DesksBound(desksBound) {
        this.desksBound = desksBound;
    }
    public get InternalId() {
        return this.internalId;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public get IntervalCapacity() {
        return this.intervalCapacity;
    }
    public set IntervalCapacity(intervalCapacity) {
        this.intervalCapacity = intervalCapacity;
    }
    public get IntervalDuration() {
        return this.intervalDuration;
    }
    public set IntervalDuration(intervalDuration) {
        this.intervalDuration = intervalDuration;
    }
    public get IntervalOccupacityAlert() {
        return this.intervalOccupacityAlert;
    }
    public set IntervalOccupacityAlert(intervalOccupacityAlert) {
        this.intervalOccupacityAlert = intervalOccupacityAlert;
    }
    public get MaxReservation() {
        return this.maxReservation;
    }
    public set MaxReservation(maxReservation) {
        this.maxReservation = maxReservation;
    }
    public get MaxTurnsPerDayByService() {
        return this.maxTurnsPerDayByService;
    }
    public set MaxTurnsPerDayByService(maxTurnsPerDayByService) {
        this.maxTurnsPerDayByService = maxTurnsPerDayByService;
    }
    public get MsessionInternalId() {
        return this.msessionInternalId;
    }
    public set MsessionInternalId(msessionInternalId) {
        this.msessionInternalId = msessionInternalId;
    }
    public get MsessionName() {
        return this.msessionName;
    }
    public get Online() {
        return this.online;
    }
    public set MsessionName(msessionName) {
        this.msessionName = msessionName;
    }
    public set Online(online) {
        this.online = online;
    }
    public get ReservationForDay() {
        return this.reservationForDay;
    }
    public set ReservationForDay(reservationForDay) {
        this.reservationForDay = reservationForDay;
    }
    public get Latitude() {
        return this.latitude;
    }
    public set Latitude(latitude) {
        this.latitude = latitude;
    }
    public get Longitude() {
        return this.longitude;
    }
    public set Longitude(longitude) {
        this.longitude = longitude;
    }
    public get DistanceInMeters() {
        return this.distanceInMeters;
    }
    public set DistanceInMeters(distanceInMeters) {
        this.distanceInMeters = distanceInMeters;
    }
    public get ShowEstimatedTime() {
        return this.showEstimatedTime;
    }
    public set ShowEstimatedTime(showEstimatedTime) {
        this.showEstimatedTime = showEstimatedTime;
    }
    public get TurnFormName() {
        return this.turnFormName;
    }
    public set TurnFormName(turnFormName) {
        this.turnFormName = turnFormName;
    }
    public get UrlTurnForm() {
        return this.urlTurnForm;
    }
    public set UrlTurnForm(urlTurnForm) {
        this.urlTurnForm = urlTurnForm;
    }
    public get UrlAppointmentForm() {
        return this.urlAppointmentForm;
    }
    public set UrlAppointmentForm(urlAppointmentForm) {
        this.urlAppointmentForm = urlAppointmentForm;
    }
    public get ShowEndTime() {
        return this.showEndTime;
    }
    public set ShowEndTime(showEndTime) {
        this.showEndTime = showEndTime;
    }
}
